var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26198_122280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 1.25C5.625 1.5957 5.3457 1.875 5 1.875H0.625C0.279297 1.875 0 1.5957 0 1.25C0 0.904297 0.279297 0.625 0.625 0.625H5C5.3457 0.625 5.625 0.904297 5.625 1.25ZM5.625 6.25C5.625 6.5957 5.3457 6.875 5 6.875H0.625C0.279297 6.875 0 6.5957 0 6.25C0 5.9043 0.279297 5.625 0.625 5.625H5C5.3457 5.625 5.625 5.9043 5.625 6.25ZM0 3.75C0 3.4043 0.279297 3.125 0.625 3.125H8.125C8.4707 3.125 8.75 3.4043 8.75 3.75C8.75 4.0957 8.4707 4.375 8.125 4.375H0.625C0.279297 4.375 0 4.0957 0 3.75ZM8.75 8.75C8.75 9.0957 8.4707 9.375 8.125 9.375H0.625C0.279297 9.375 0 9.0957 0 8.75C0 8.4043 0.279297 8.125 0.625 8.125H8.125C8.4707 8.125 8.75 8.4043 8.75 8.75Z",
    fill: "#626F86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26198_122280"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H8.75V10H0V0Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentIcon);
export default __webpack_public_path__ + "static/media/contentIcon.efec1cdfd4eedb24834652c771bc654b.svg";
export { ForwardRef as ReactComponent };